/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { useRef, useCallback } from "react";
import { cn } from "tailwind-variants";

export default function PinComposer({
  modelValue = "",
  canSubmit = false,
  isProcessing = false,
  isRemoving = false,
  compact = false,
  onUpdateModelValue,
  onSubmit,
  onCancel,
  onNewline,
  onTextareaRef,
  ...restProps
}: any) {
  const prevTextareaElRef = useRef(null);

  const autoFocusTextarea = useCallback(
    (el: any) => {
      onTextareaRef?.(el);
      if (el && el !== prevTextareaElRef.current) {
        prevTextareaElRef.current = el;
        setTimeout(() => el.focus(), 0);
      }
      if (!el) {
        prevTextareaElRef.current = null;
      }
    },
    [onTextareaRef]
  );

  function handleKeyDown(e: any) {
    if (e.key === "Enter") {
      if (e.metaKey || e.ctrlKey) {
        e.preventDefault();
        const { selectionStart, selectionEnd } = e.target;
        const val = modelValue;
        const newValue = `${val.slice(0, selectionStart)}\n${val.slice(selectionEnd)}`;
        onUpdateModelValue?.(newValue);
        onNewline?.(selectionStart + 1);
        return;
      }
      e.preventDefault();
      if (!isProcessing && canSubmit) {
        onSubmit?.();
      }
    }
  }

  return (
    <div {...restProps}>
      <div className={cn("flex", compact ? "gap-1.5" : "gap-2")}>
        <textarea
          className={cn(
            "mp-unmask flex-1 resize-none rounded-md border border-gray-300 outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-600",
            compact ? "min-h-[36px] px-2 py-1" : "min-h-[44px] px-3 py-2"
          )}
          ref={autoFocusTextarea}
          value={modelValue}
          placeholder="Add your instructions here..."
          disabled={isProcessing}
          style={{ fontSize: "16px" }}
          data-testid="pinning-composer"
          onChange={e => {
            onUpdateModelValue?.(e.target.value);
          }}
          onKeyDown={handleKeyDown}
        />
      </div>
      <div className={cn("flex justify-end", compact ? "mt-1 gap-1.5" : "mt-2 gap-2")}>
        <button
          className={cn(
            "cursor-pointer border-none bg-transparent font-medium text-gray-500 hover:text-gray-700",
            compact ? "!text-[11px]" : "text-xs"
          )}
          type="button"
          disabled={isRemoving}
          data-testid="pin-composer-cancel"
          onClick={() => {
            onCancel?.();
          }}
        >
          {isRemoving ? "Removing..." : "Cancel"}
        </button>
        <button
          className={cn(
            "cursor-pointer rounded-[4px] border-none bg-[#414192] font-bold !text-white hover:bg-[#06065a] disabled:cursor-not-allowed disabled:opacity-50",
            compact ? "px-2.5 py-0.5 !text-[11px]" : "px-4 py-1.5 text-xs"
          )}
          type="button"
          disabled={isProcessing || !canSubmit}
          data-testid="pinning-send"
          onClick={() => {
            onSubmit?.();
          }}
        >
          {" "}
          Submit{" "}
        </button>
      </div>
    </div>
  );
}

PinComposer.displayName = "PinComposer";
